// vendor
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

type NotificationVariant = 'error' | 'warning' | 'success' | 'information';

@Component({
    selector: 'app-notification',
    styleUrls: ['./notification.component.scss'],
    templateUrl: './notification.component.html',
    imports: [CommonModule]
})
export class NotificationComponent {
  public _variant: NotificationVariant = 'information';

  /**
   * This is a setter to accommodate backwards compatibility with the
   * deprecated 'error' input above.
   */
  @Input()
  set variant(value: NotificationVariant) {
    if (value) this._variant = value;
  }
}
